define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/html",
	"csi/property/Widget"
], function(declare, _, html, PropertyWidget) {

	return declare(PropertyWidget, {
		_isCompositeSizeRange() {
			// summary: return if size range is composite
			return this.getViewNode()?.SizeChartSubranges.length > 1;
		},

		_postViewDeferred(/*Context*/ctx, /*Deferred[]*/dfds) {
			// summary: insert sub-range view if multiple
			this._deleteViewLayout();
			html.setVisible(this.actionsNode, false);

			if (this._isCompositeSizeRange()) {
				const div = this.getExtraPropertyDiv("propertyViewActions");

				dfds.push(this._insertAndCreateView("SubSizeRanges", this.getViewNode(), div).then((view) => {
					this.viewLayout = view;
					html.setVisible(this.actionsNode, true);
				}));
			}
		}
	});
});